import { Injectable } from '@angular/core';
import { datadogRum } from '@datadog/browser-rum';
import { environment } from 'src/environments/environment';

enum DatadogPrivacyLevels {
    MASK_USER_INPUT = 'mask-user-input',
    MASK = 'mask',
    ALLOW = 'allow'
}
@Injectable({
  providedIn: 'root',
})
export class DatadogService {

  public initDatadog(applicationId: string, clientToken: string) {
    if (environment.CONFIGURATION === 'development' ||
        !environment.datadogMonitoring ||
        !applicationId ||
        !clientToken) {
      return;
    }

    datadogRum.init({
      applicationId: applicationId,
      clientToken: clientToken,
      site: 'datadoghq.com',
      service: environment.datadogService,
      env: environment.datadogEnv,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      defaultPrivacyLevel: DatadogPrivacyLevels.MASK_USER_INPUT,
      allowedTracingUrls: [environment.API_URL]
    });

    datadogRum.startSessionReplayRecording();
  }
}
